<template>
    <div class="style-wrap section-wrap">
        <div class="customize-box">
            <div class="title-price">
                <span>个性定制</span>
                <span></span>
            </div>
            <div class="fabric-title">位置</div>
            <div class="position-list">

                <div class="position-item" v-for="(item, index) in customize_data" @click="change_position(index)" :class="{active: current_position === index}">
                    <div class="item-wrap">
                        <img class="position-image" :src="item.image" alt="">
                    </div>
                    <p class="position-name">{{item.name}}</p>
                </div>
            </div>

            <div class="fabric-title">当前部位</div>
            <div style="">
                <span style="font-size: 14px">{{current_style_data.name}}</span>
                <span class="btn-customize-cancel" @click.stop="remove_style(current_style_data)" >取消</span>
            </div>

            <div class="fabric-title">个性内容</div>

            <div class="content-type-list">
                <div class="content-item" v-for="(item, index) in content_type_list" @click="change_content_type(item.type)" >
                    <img class="content-type-radio" src="@/assets/images/select.png" alt="" v-if="current_style_data.type === item.type" />
                    <img class="content-type-radio" src="@/assets/images/no-select.png" alt="" v-else />
                    {{item.name}}
                </div>
            </div>

            <div class="customize-area" v-if="current_style_data.type != 2">
                <div class="customize-text-wrap">
                    <span class="title">文字内容：</span>
                    <input placeholder="不多于10个英文字母" type="text" :value="current_style_data.text_value" @input="update_text" class="customize-text" />
                </div>
                <div class="customize-font-wrap">
                    <span class="title">字体样式：</span>
                    <div class="font-list">
                        <div class="font-item" v-for="(item, index) in current_option.setting.text.font_list" :key="'text-font-' + index" @click="change_font(item.font_name)">
                            <img :src="item.font_image" alt="" class="font-image" />
                            <img class="font-radio" src="@/assets/images/select.png" alt="" v-if="current_style_data.text_font===item.font_name" />
                            <img class="font-radio" src="@/assets/images/no-select.png" alt="" v-else />
                        </div>
                    </div>
                </div>
                <div class="customize-color-wrap">
                    <span class="title">字体颜色：</span>
                    <div class="color-list">
                        <div class="color-item"
                             v-for="(item, index) in current_option.setting.text.color_list"
                             :key="'text-color-' + index"
                             @click="change_color(item.color_key)"
                             v-if="available_text_color_list.length === 0 || available_text_color_list.includes(item.color_key)"
                        >
                            <div class="item-wrap">
                                <img :src="item.color_image" alt="" class="color-image" />
                                <img class="color-radio" src="@/assets/images/select.png" alt="" v-if="current_style_data.text_color===item.color_key" />
                                <img class="color-radio" src="@/assets/images/no-select.png" alt="" v-else />
                            </div>
                            <p class="color-name">{{item.color_name}}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="customize-area" v-else>
                <input type="file" ref="file" style="display: none" @change="upload">
                <div class="customize-picture">
                    <img :src="current_style_data.image_value + '?x-oss-process=image/resize,w_100,limit_0'" alt="" class="img-wrap" v-if="current_style_data.image_value" @click="change_picture">
                    <img src="@/assets/images/design/add-rect@2x.png" alt="" class="img-wrap" @click="change_picture" v-else >

                </div>
            </div>

            <div class="fabric-title">制作方式</div>
            <div class="print-type-list">
                <div class="print-item" v-for="(item, index) in print_type_list" @click="change_print_type(item.type)" :class="{forbid: allow_tech!= 9 && allow_tech != item.type}">
                    <img class="print-type-radio" src="@/assets/images/disable-select.png" alt="" v-if="allow_tech!= 9 && allow_tech != item.type"  />
                    <img class="print-type-radio" src="@/assets/images/select.png" alt="" v-else-if="current_style_data.print_type === item.type" />
                    <img class="print-type-radio" src="@/assets/images/no-select.png" alt="" v-else  />
                    {{item.name}}
                </div>
            </div>

        </div>
    </div>

</template>

<script>
    import {mapState} from 'vuex'
    import { uploadFile } from "@/api"
    const raw_style_data = {
        code: "",
        name: "",
        type: 0,
        text_value: '',
        text_font: '',
        text_color: '',
        price_yh: 0,
        price_xh: 0,
        print_type: 0,
        image_value: ''
    }
    export default {
        name: "Style",
        data() {
            return {
                current_position: 0,
                current_style_data: { ...raw_style_data },
                content_type_list: [
                    {
                        name: '文字',
                        type: 1,
                    },
                    {
                        name: '图案',
                        type: 2,
                    }
                ],
                print_type_list: [
                    {
                        name: '压花',
                        type: 1,
                    },
                    {
                        name: '绣花',
                        type: 2,
                    }
                ],
            }
        },
        computed: {
            ...mapState({
                customize_data: (state) => state.mtm.picked_category.customize_data,
                style_data: (state) => state.mtm.form_data.customize_data,
                current_color: (state) => state.mtm.form_data.fabric_list.color,
            }),
            confirm_style_code() {
                return this.style_data.map((item) => item.code)
            },
            current_option() {
                return this.customize_data[this.current_position]
            },
            style_price() {
                let result = 0
                for(let i in this.style_data) {
                    result += parseFloat(this.style_data[i].price_yh) + parseFloat(this.style_data[i].price_xh)
                }

                return result.toFixed(2)
            },
            available_text_color_list() {
                if(!this.current_color.text_color_list) {
                    return []
                }

                return this.current_color.text_color_list.map((item) => item.color_key)
            },
            allow_tech() {
                return this.current_color.tech
            }
        },
        methods: {
            change_position(index) {
                this.current_position = index
                let object = this.style_data.find((item) => {
                    return item.code === this.customize_data[index].code
                })
                this.current_style_data = object || {...raw_style_data, code: this.customize_data[index].code, name: this.customize_data[index].name}
            },
            change_content_type(type) {
                this.current_style_data.type = type
                if(this.current_style_data.type == 1 && this.current_style_data.print_type == 1) {
                    this.current_style_data.price_yh = this.customize_data[this.current_position].setting.text.price_yh
                    this.current_style_data.price_xh = 0
                }
                if(this.current_style_data.type == 1 && this.current_style_data.print_type == 2) {
                    this.current_style_data.price_yh = 0
                    this.current_style_data.price_xh = this.customize_data[this.current_position].setting.text.price_xh
                }
                if(this.current_style_data.type == 2 && this.current_style_data.print_type == 1) {
                    this.current_style_data.price_yh = this.customize_data[this.current_position].setting.image.price_yh
                    this.current_style_data.price_xh = 0
                }
                if(this.current_style_data.type == 2 && this.current_style_data.print_type == 2) {
                    this.current_style_data.price_yh = 0
                    this.current_style_data.price_xh = this.customize_data[this.current_position].setting.image.price_xh
                }
                this.update_customize_data()
            },
            update_text(e) {
                this.current_style_data.text_value = e.target.value
                this.update_customize_data()
            },
            change_font(font) {
                this.current_style_data.text_font = font
                this.update_customize_data()
            },
            change_color(color) {
                this.current_style_data.text_color = color
                this.update_customize_data()
            },
            change_print_type(type) {
                if(this.allow_tech != 9 && this.allow_tech != type) {
                    this.$Message.error("该面料不适合此工艺~")
                    return
                }
                this.current_style_data.print_type = type
                if(this.current_style_data.type == 1 && this.current_style_data.print_type == 1) {
                    this.current_style_data.price_yh = this.customize_data[this.current_position].setting.text.price_yh
                    this.current_style_data.price_xh = 0
                }
                if(this.current_style_data.type == 1 && this.current_style_data.print_type == 2) {
                    this.current_style_data.price_yh = 0
                    this.current_style_data.price_xh = this.customize_data[this.current_position].setting.text.price_xh
                }
                if(this.current_style_data.type == 2 && this.current_style_data.print_type == 1) {
                    this.current_style_data.price_yh = this.customize_data[this.current_position].setting.image.price_yh
                    this.current_style_data.price_xh = 0
                }
                if(this.current_style_data.type == 2 && this.current_style_data.print_type == 2) {
                    this.current_style_data.price_yh = 0
                    this.current_style_data.price_xh = this.customize_data[this.current_position].setting.image.price_xh
                }
                this.update_customize_data()
            },
            change_picture() {
                this.$refs.file.click();
            },
            remove_style(item) {
                this.$store.commit('mtm/remove_customize_data', {code: item.code})
                if(this.current_style_data.code == item.code) {
                    this.current_style_data = {...raw_style_data, code: item.code, name: item.name, type: 1}
                }
            },
            upload(e) {
                let file = e.target.files[0]
                if(file.size > 10 * 1024 * 1024) {
                    this.$Message.error("文件不能超过10M")
                    return
                }
                if(!['image/jpeg', 'image/jpg', 'image/png'].includes(file.type)) {
                    this.$Message.error("文件类型只能是jpg,jpeg,png")
                    return
                }
                uploadFile(file, 'mtm_style').then(response => {
                    this.current_style_data.image_value = response.data.url
                    this.update_customize_data()
                }).finally(() => {
                    this.$refs.file.value = ''
                })
            },
            update_customize_data() {
                this.$store.commit('mtm/update_customize_data', {
                    code: this.customize_data[this.current_position].code,
                    data: this.current_style_data
                })
            },
        },
        created() {
            this.change_position(0)
        }
    }
</script>

<style  lang="scss">
    .customize-box {
        padding-right: 20px;
        .btn-customize-cancel {
            margin-left: 10rpx;
            padding: 3px 8px;
            color: red;
            cursor: pointer;
        }
        .title-price {
            margin-top: 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 16px;
            color: #0f114a;
            font-weight: bold;
        }

        .fabric-title {
            font-size: 15px;
            font-family: PingFang SC;
            font-weight: bold;
            line-height: 18px;
            color: #333333;
            border-bottom: 1px solid #dddddd;
            padding-bottom: 10px;
            margin-top: 32px;
        }

        .position-list {
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;
            .position-item{
                width: 105px;
                text-align: center;
                cursor: pointer;
                margin:10px 8px 0 0;
                &:nth-child(3n) {
                    margin-right: 0;
                }
                .item-wrap {
                    display: flex;
                    justify-content: center;
                    flex-wrap: wrap;
                    align-items: center;
                    position: relative;
                    border: 1px dashed black;
                    box-sizing: border-box;

                    .position-image {
                        width: 70px;
                        height: 70px;
                        border: 0;
                        margin: 0;
                    }
                    .position-radio {
                        position: absolute;
                        top: 5px;
                        right: 5px;
                        width: 13px;
                        height: 13px;
                    }
                }

                .position-name {
                    width: 100%;
                    font-size: 14px;
                }

                &.active {
                    .item-wrap {
                        border: 2px solid #0f114a;
                    }
                    .position-name {
                        color: #0f114a;
                        font-weight: bold;
                    }
                }
            }
        }

        .content-type-list {
            margin: 10px 0;
            display: flex;
            .content-item {
                display: flex;
                align-items: center;
                margin-right:60px;
                height: 20px;
                line-height: 20px;
                font-size: 16px;
                .content-type-radio {
                    width: 16px;
                    height: 16px;
                    margin-top: 2px;
                    margin-right: 5px;
                }
            }
        }

        .customize-area {
            background: #F3F4F5;
            margin: 5px 0;
            padding: 10px 10px;
            border-radius: 2px;
            .title {
                width: 70px;
                height: 20px;
                line-height: 20px;
                font-size: 14px;
                color: #333333;
            }
            .customize-text-wrap {
                margin: 10px 0;
                .customize-text {
                    margin-left: 10px;
                    width: 220px;
                    height: 36px;
                    padding: 10px;
                    line-height: 36px;
                    border: none;
                }
            }
            .customize-font-wrap {
                margin: 10px 0;
                .font-list {
                    display: flex;
                    justify-content: flex-start;
                    flex-wrap: wrap;
                    .font-item {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        position: relative;
                        width: 100px;
                        text-align: center;
                        margin:10px 8px 0 0;
                        background: white;
                        padding: 2px;
                        cursor: pointer;
                        &:nth-child(3n) {
                            margin-right: 0;
                        }
                        .font-image {
                            width: 98px;
                            height: 42px;
                            border: 0;
                            margin: 0;
                        }
                        .font-radio {
                            position: absolute;
                            top: 5px;
                            right: 5px;
                            width: 13px;
                            height: 13px;
                        }
                    }
                }
            }
            .customize-color-wrap {
                margin: 10px 0;
                .color-list {
                    display: flex;
                    justify-content: flex-start;
                    flex-wrap: wrap;
                    .color-item {
                        width: 42px;
                        text-align: center;
                        margin:10px 8px 0 0;
                        cursor: pointer;
                        &:nth-child(3n) {
                            margin-right: 0;
                        }
                        .item-wrap{
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            position: relative;
                            .color-image {
                                width: 42px;
                                height: 42px;
                                border: 0;
                                margin: 0;
                            }
                            .color-radio {
                                position: absolute;
                                top: 5px;
                                right: 5px;
                                width: 13px;
                                height: 13px;
                            }
                        }
                        .color-name {
                            font-size: 14px;
                        }
                    }
                }
            }

            .customize-picture {
                width: 275px;
                margin:0 20px;
                text-align: center;
                .img-wrap {
                    cursor: pointer;
                    width: auto;
                    height: 120px;
                }
            }
        }

        .print-type-list {
            margin-top: 10px;
            display: flex;
            .print-item {
                display: flex;
                align-items: center;
                margin-right:60px;
                height: 20px;
                line-height: 20px;
                font-size: 16px;
                .print-type-radio {
                    width: 16px;
                    height: 16px;
                    margin-right: 5px;
                }
                &.forbid {
                    color: #999;
                }
            }

        }


    }

</style>
